module.exports = __webpack_public_path__ + "static/media/google-play.8f5da2b2.svg";